export const INSPECTION_TIME = [
  { id: "1", name: "日" },
  { id: "2", name: "週" },
  { id: "3", name: "月" },
  { id: "4", name: "年" },
  { id: "5", name: "その他" },
];
export const TYPE_INPUT = {
  NUMBER: "10000",
  TEXT: "01000",
  SELECT: "00100",
  RATIO: "00010",
  TEXT_AREA: "00001",
};
export const COMMON_CONSTANT = {
  // DungDV21
  CONFIRM_DELETE: "取消してもいいですか？", //  Can I delete?
  CONFIRM_ACCEPT: "確定してもいいですか？", //  Can I confirm?
  NOTE_ACCEPT: "※注意：確定すると、現時点の情報で固定されます。",
  CONFIRM_RETURN_ACCEPT: "元請を解除してもいいですか？",
  NOTE_RETURN_ACCEPT: "※注意：解除すると、情報を更新されます。",
  CONFIRM_ACCEPT_SUB: "下請を確定してもいいですか？",
  CONFIRM_LOCK_CONTRACT: "下請簿完了でいいですか？",
  CONFIRM_UNLOCK_CONTRACT: "下請簿完了のチェックを外しますか？",
  CONFIRM_ACCEPT_SUB_NOTE: "※注意：確定すると、現時点の情報で固定されます。",
  CONFIRM_RETUN_ACCEPT_SUB: "下請を解除してもいいですか？",
  CONFIRM_RETUN_ACCEPT_SUB_NOTE: "※注意：解除すると、情報を更新されます。",
  CONFIRM_CONTRACT_ACCEPT: "元請を確定してもいいですか？",
  DELETE_CHECKEDBOX_CONFIRM: "選択した複数製番を取消してもいいですか？",
  CONFIRM_UPDATE_REPRESENTATIVE: "今、編集した内容が保存されます。", // Are you sure you want to update?
  CONFIRM_UPDATE_REPRESENTATIVE_ACCEPT: "※注意：保存した内容は更新されます。",
  CONFIRM_REGISTER_REPRESENTATIVE: "登録してもいいですか？",
  CONFIRM_REGISTER_SUBCONTRACTNUMBER: "新しい許可番号を登録してもいいですか？",
  CONFIRM_ACC_SUBCONTRACT: "今、編集した内容が保存確定されますが、よろしいですか。",
  CONFIRM_DEL_SUBCONTRACT: "下請を解除してもいいですか？",
  CONFIRM_ACC_SUBCONTRACT_SUB: "※注意：確定すると、現時点の情報で固定されます。",
  CONFIRM_DEL_SUBCONTRACT_SUB: "※注意：解除すると、情報を更新されます。",
  INPUT_FORMAT_NUM: "数字",
  INPUT_FORMAT_CHAR: "文字",
  INPUT_FORMAT_CHAR_1: "テキスト",
  INPUT_FORMAT_CHOI: "選択",
  INPUT_FORMAT_CHOI_1: "選択肢",
  INPUT_FORMAT_YESNO: "無/有",
  INSPECTION_TIMING_OTHER: "その他",
  // BOM_I001: "データがありません。",
  BOM_I002: "アイテムがすでに点検表に追加されています。",
  BOM_I003: "機器がすでに追加されています。",
  BOM_C001: "削除してもよろしいですか？", // Delete Are you sure you want to?
  BOM_C00108: "復旧してもいいですか?", // Can I restore it?
  BOM_C002: "正常に取り込まれた。",
  //TamNm10 start
  RESET: "リセットしてもいいですか？",
  REVERT_MANY: "選択した複数製番を復旧してもいいですか？",
  CONFIRM_SAVE: "保存してもいいですか？",
  CONFIRM_DEL: "削除してもいいですか？",
  //TamNM10 end
  BOM_C003: "正常に保存しました。", //"Saved successfully.",
  BOM_C004: "正常に削除しました。", // "Deleted successfully.",
  BOM_C005: "正常に出力されました。",
  BOM_C006: "保存してもよろしいですか？",
  BOM_C008: "入力内容を登録してもよろしいですか？",
  BOM_C009: "入力内容を更新してもよろしいですか？",
  BOM_C013: "この点検表を承認してもよろしいですか？",
  BOM_C018:
    "いくつかの値が変更されています。このページから離れてもよろしいですか？",
  BOM_C019: "この点検表を拒否してもよろしいですか？",
  BOM_C021: "点検頻度を変更してもよろしいですか？",
  BOM_C022: "選択したレコードに変更がある為、操作が完了しませんでした。",
  BOM_C030:
    "選択した点検表は既に{user}さんによってアクセスされています。後でもう一度お試しください。",
  BOM_C032: "この機器を削除してもよろしいですか？",
  BOM_C033: "このグループを削除してもよろしいですか？",
  BOM_C035:
    "点検表にデータが既に入力されました。この点検表に対してこの操作を実施できない。",
  BOM_C038: "この点検表を承認解除してもよろしいですか？",
  BOM_C039: "正常に復旧しました。",
  BOM_C040: "ユーザーを追加しました。",
  BOM_C041: "「保存」ボタンを押下してください。",
  BOM_E003:
    "ファイルフォーマットが無効です。正しいフォーマットを選択してください。",
  BOM_E004:
    "インターネットに接続されていません。接続してから再度お試しください。",
  BOM_E005: "出力するデータが存在していません。",
  BOM_E006: "ファイル内容が無効です。他のファイルを選択してください。",
  BOM_E007: "タイムアウトしました。もう一度お試してください。",
  BOM_E008: "サーバーエラー。もう一度お試してください。",
  BOM_E009: "入力したデータが既にシステムに存在している。",
  BOM_E015: "カメラの起動に失敗しました。",
  BOM_E018:
    "部品コード前は既にシステムに存在しています。再度ご検証しください。",
  BOM_E021:
    "「出庫数量」フィールドに「在庫数量」フィールドの値より高い値を入力してはいけない。再度お試しください。",
  BOM_E022:
    "日付のフィールドに今日または今日よりも過去日を入力しなけければなりません。再度お試しください。 ",
  BOM_E023: "有効期限は投稿日または投稿日よりも未来日を入力してください。",
  BOM_E025:
    "「製造年月日」フィールドに「入庫日」フィールドの値より高い値を入力してはいけない。再度お試しください。",
  BOM_E026:
    "「製造年月日」フィールドに「出庫日」フィールドの値より高い値を入力してはいけない。再度お試しください。",
  BOM_E027:
    "機器分類マスターの名前は既にシステムに存在しています。再度ご検証しください。",
  BOM_E028: "点検区分を変更してもよろしいですか？",
  BOM_E029: "正常に失敗しました。",
  BOM_E030: "入力データが無効です。再チェックしてください。",
  BOM_E031: "全ての入力必須フィールドにデータを入力していません。",
  BOM_E032: "出庫数量は在庫数量以下でなければなりません。",
  BOM_E033: "入庫数量は0より大きいでなければなりません。",
  BOM_E034: "出庫数量は0より大きいでなければなりません。",
  BOM_E035: "メールアドレスを入力してください。", // Please enter your email address.
  BOM_E036: "メールアドレスが不正です。", // Invalid email

  BOM_W001: "の取引先は画面非表示となっているので、取引先マスターで表示に更新して下さい",
  BOM_W001_1: "取引先コード",
  EMPTY_DATA: "データがありません。",
  EDIT_OPTION: "編集",
  VIEW_OPTION: "閲覧",
  DELETE_OPTION: "削除",
  CUSTOM_LIST_CHECK_ITEM: "CheckItem",
  WORK_REPORT_STATUS_OPENED: "オープン",
  WORK_REPORT_STATUS_REJECTED: "拒否済",
  WORK_REPORT_STATUS_RESOLVED: "解決済",
  WORK_REPORT_STATUS_CONFIRMED: "確認済",
  WORK_REPORT_STATUS_APPROVED: "承認済",
  WORK_REPORT_STATUS_REOPENED: "再開済",
  NEW_DATA_TEMPLATE_CODE: "#{0}#HD{1}",
  SPECIAL_CHARACTER: {},
  REJECTED: "REJECTED",
  CONFIRMED: "CONFIRMED",
  APPROVED: "APPROVED",
  RESOLVED: "SOLVED",
  SAVE_DRAFT: "下書きとして保存",
  SAVE: "保存 ",
  CLEAR: "キャンセル",
  TITLE_UPDATE_GROUP: "グループを更新",
  TITLE_CREATE_GROUP: "グループを追加",
  TITLE_DEL_GROUP: "グループ削除",
  GROUP_NAME: "グループ名",
  GROUP_TYPE: "グループ種類",
  CLOSE: "閉じる",
  ADD: "追加 ",
  BUTTON_ROLE: "権限マトリックス",
  UPDATE: "保存 ",
  BACK: "戻る",
  CONFIRM_SAVE: "保存確定 ",
  GROUP_NAME_EXISTS: "このグループ名は存在する。",
  CONFIRM_REVERT_SUBCONTRACT: "復旧してもいいですか？",
  THERE_IS_NO_SUBCONTRACTOR: "下請簿が存在していません。",
  USER_UNAUTHORIZED:
    "この機能を操作する権限がありません! 管理者に連絡してください！",
  COMFIRM_REMOVE_SUBCONTRACT: "取消してもよろしいでしょうか",
  COMFIRM_ACCEPT_CONTRACT: "確定してもよろしいでしょうか",
  COMFIRM_DELETE_ALL: "取消してもいいですか。",
  COMFIRM_REVERT_ALL: "選択した複数製番を復旧してもいいですか？",
  MESSAGE_CONFIRM_SAVE_SUB_CONTRACT:
    "今、編集した内容が保存されます。",
  MESSAGE_CONFIRM_SAVE_CONFIRM_SUB_CONTRACT:
    "今、編集した内容が保存確定されますが、よろしいですか。",
  MESSAGE_CONFIRM_SAVE_CONTRACT_NOTE: "※注意：保存した内容は更新されます。",
  MESSAGE_FILE_NOT_FOUND: "ファイルが見つかりません。",
};

export const lang = {
  // TamNM10 START
  TITLE_DEL_PARENT_CONTRACT: "元請取消一覧",
  REJECT_SUBCONTRACT_UPDATE: "下請編集",
  REJECT_SUBCONTRACT_CREATE: "下請作成",
  FULL_NAME: "氏名",
  SHI_ID: "SHI-ID",
  // TamNM10 END
  UPLOAD: "アップロード",
  ADMIN_GROUP: "グループ管理者",
  GROUP_COMMON: "共通",
  GROUP_USER: "個人",
  NEWEST_VERSION: "最新バージョン",
  OFFICIAL: "正式",
  DRAFT: "下書",
  ADDED: "追加された",
  NOT_ADDED: "追加されませんでした",
  MACHINES: "機械",
  INPUT: "入力",
  FACILITY: "施設",
  BUILDING: "棟",
  FLOOR: "階",
  ROOM: "部屋",
  PROCESS: "プロセス",
  RESET: "リセット",
  MACHINE_ONLY: "機械のみ",
  REMARK_ITEM: "備考項目",
  SENDER: "送信元",
  GENERAL: "一般",
  IDENTIFICATION: "特定",
  GENERAL2: "般",
  SPECIAL: "特",
  SUBNO: "第",
  ISSUE: "号",
  LEFTBRACKET: "（",
  RIGHTBRACKET: "）",
  MINUS: "-",

  NAME_SYSTEM: "建設業帳簿管理システム",
  LIST_CHECKLIST: "点検表登録",
  INFO_CHECKLIST: "点検情報",
  CREATE_CHECKLIST: "点検表作成",
  CLONE_CHECKLIST: "点検表参照作成",
  EDIT_CHECKLIST: "点検表情報更新",
  HISTORY_CHECKLIST: "点検履歴",
  SAMPLE_TEMP_MANAGEMENT: "報告テンプレート管理",
  EXPORT_REPORT: "報告書出力",
  IMPORT_CSV: "CSVファイル入力",
  WORK_REPORT_MANAGEMENT: "作業報告管理",
  ROLE_SETTING: "権限設定",
  REGISTRY_ORIGIN_DATA: "初期データ登録",
  CL_MANAGEMENT: "点検管理",
  REPORT_MANAGEMENT: "報告管理",
  REGISTRY_MACHINE: "機器台帳登録",
  REGISTRY_INVENTORY: "倉庫マスターデータ登録",
  OFFICE_DETAIL: "事業所情報",
  EDIT_OFFICE_DETAIL: "事業所情報更新",
  OFFICE_MANAGEMENT: "事業所情報管理",
  CREATE_OFFICE_DETAIL: "事業所情報登録",
  SC_REST_LAST_VALUE: "総累計リセット",

  INVENTORY: "在庫",
  IMPORT_INVENTORY: "入庫レコード",
  IMPORT_INVENTORY_UPDATE_BUTTON: "更新",
  IMPORT_INVENTORY_ADD: "入庫レコード追加",
  IMPORT_INVENTORY_UPDATE: "入庫レコード更新",
  IMPORT_INVENTORY_VIEW: "入庫レコード詳細",
  EXPORT_INVENTORY: "出庫レコード",
  EXPORT_INVENTORY_UPDATE_BUTTON: "更新",
  EXPORT_INVENTORY_ADD: "出庫レコード追加",
  EXPORT_INVENTORY_UPDATE: "出庫レコード更新",
  EXPORT_INVENTORY_VIEW: "出庫レコード詳細",

  WAREHOUSES_MASTER: "倉庫",
  WAREHOUSES_NAME: "倉庫名称",
  WAREHOUSES_CODE: "倉庫コード",
  CATEGORY_MASTER: "カテゴリー",
  CATEGORY_NAME: "カテゴリー名",
  CATEGORY_CODE: "カテゴリーコード",
  ITEM_MASTER: "項目",
  ITEM_NAME: "項目名",
  ITEM_CODE: "項目コード",
  INVENTORY_DATA: "在庫数量",
  STOCK: "在庫履歴",

  AUTO_EXPORT_INVENTORY: "出庫取引自動作成",
  TRADING_CODE: "取引コード",
  STORAGE: "倉庫",
  IMPORTER: "入庫者",
  IMPORT_DATE: "入庫日",
  EXPORTER: "出庫者",
  EXPORT_DATE: "出庫日",
  CREATE_DATE: "作成日",
  UPDATE_DATE: "更新日",
  CREATOR: "作成者",
  UPDATER: "更新者",
  ITEM_TYPE: "項目種別",
  STOCK_QUANTITY: "在庫数量",
  MINIMUM_STOCK_QUANTITY: "最小在庫数量",
  MANUFACTURER: "メーカー",
  MAKER_MODEL_NUMBER: "型式",
  SAMPLES: "例",
  NUMBER: "本数",
  RECEIVING_UNIT: "入荷計算単位",
  INVENTORY_UNIT: "在庫計算単位",
  INVENTORY_QUANTITY: "入庫数量",
  CONVERSION_RATE: "換算率",
  TYPE_OF_MACHINE_USED: "使用機器種類",
  RETAILER: "購入先",
  ORDER_NUMBER: "伝票数",
  REMARKS: "記入",
  INVENTORY_INFORMATION: "在庫情報",
  SHOW_ONLY_ALERTED_ITEMS: "警報項目のみ表示",
  SHOW: "示す",
  READ_MORE: "もっと見る",
  ENDING_STOCK_QUANTITY: "期末在庫数量",
  BEGINING_STOCK_QUANTITY: "期首在庫数量",
  STOCK_OUT_QUANTITY: "出庫レコード",
  STOCK_IN_QUANTITY: "入庫レコード",
  QUANTITY_IMPORT: "入荷数量",
  QUANTITY_EXPORT: "出庫数量",
  UNIT_PRICE: "単価",
  AMOUNT: "金額",
  TOTAL: "合計",
  ADD_MACHINE: "機器追加",

  NEW: "新規",
  DATE: "日",
  WEEK: "週",
  MONTH: "月",
  YEAR: "年",
  COLON: "：",
  TODO_CHECKLIST: "点検実施",
  BOOKMARK: "ブックマーク",
  CHECK_RESULT: "進行中",
  FILTER: "フィルタ",
  CHECKLIST: "点検",
  DELETE_GROUP: "グループを削除",
  EDIT_GROUP: "グループエディター",
  ADD_TO_GROUP: "グループを追加",
  CHECKLIST_NAME: "点検書式名",
  ALL_CHECKLIST: "すべて",
  ACTION: "アクション",
  SELECT: "選択 ",
  OK: "OK",
  ERROR: "失敗",
  SUCCESS: "成功",
  WARMING: "注意",
  SETTING: "表示設定",
  ADD: "新規作成", // Create
  ADD_CHECKLIST: "点検追加",
  CANCEL: "キャンセル",
  TRADINGPARTNERMASTER: "取引先マスター",
  COMPANYNAME: "会社名",
  SEARCH: "検索 ",
  // EMPTY: "データがありません。",
  CLOSE: "閉じる",
  CLEAR: "クリアー",
  RESET_TITLE: "リセットし",
  EXPORT: "ファイル出力",
  DLEETE: "削除",
  REVERT: "復旧",
  DELETE_ALL: "全て削除",
  BUTTONHIDENMASTER: "非表示",
  BUTTONSHOWMASTER: "表示",
  MSDISPLAY1: "表示後は、下請簿＞取消一覧にある",
  MSDISPLAY2: "当該取引先全てが非表示から表示になり、下請簿一覧に移動します。",
  MSDISPLAY3: "（下請簿を",
  MSDISPLAY4: "していれば情報は更新されません）",
  MSDISPLAY5: "未確定の",
  MSDISPLAY6: "確定",
  MSHIDDEN1: "非表示後は、下請簿一覧にある",
  MSHIDDEN2: "当該取引先全てが表示から非表示になり、下請簿＞取消一覧に移動します。",
  APPROVE: "承認 ",
  UNAPPROVE: "承認解除",
  REJECT: "拒否 ",
  ATTACH: "添付ファイル",
  NORMAL_USER_VIEW: "普通ユーザ表示",
  BACK: "戻る",
  DYNAMIC_REPORT: "データグラフ確認",
  LOCATION_MACHINE: "位置情報",
  REASON_FOR_REJECT: "拒否の理由",
  REQUIRED: "必須",
  EDIT: "編集 ",
  VERSION_UP: "バージョンアップ",
  VIEW: "閲覧",
  CLONE: "参照作成",
  CONFIRM: "確認 ",
  APPROVED: "承認済",
  UNAPPROVED: "未承認",
  RESOLVE: "解決 ",
  LIST_VERSION: "バージョン一覧",
  VERSION: "ver.",
  SAVE: "保存",
  DISCARD: "廃棄",
  ALL: "全て",
  SEE_ALL: "全て表示",
  EXPEND_ALL: "すべて展開",
  ID: "ID",
  NUMBER_ORDER: "No",
  REPORT_NAME: "報告名",
  REPORT_DATE: "報告日",
  REPLENISHMENT: "補充量",
  ERROR_PATTERN: "属性の形式と一致していません。",
  SUPPORT_CHECK_PERSON: "補助点検者",
  PREVIEW: "プレビュー",
  FILE_NAME: "ファイル名",
  REMARKS_AND_MEDIA_INSERTION_OPERATION: "備考とメヂイアの挿入と操作",
  ITEM: "項目",
  TIME: "日時",
  INSPECTOR: "担当",
  SAVE_NORMAL: "正常保存",
  SAVE_DRAFT: "下書保存",
  SAVE_REPORT: "作業報告",
  REPAIR_METHOD: "改修方法",
  SAVE_TROUBLE_REPORT: "トラブル報告",
  REPORT: "報告",
  REPORT_LEVEL: "報告レベル",
  PRIORITY: "優先度",
  CHECKLIST_SCREEN: "点検画面",
  REPORT_STATUS: "トラブル報告処理状況",
  EQUIPMENT_NAME: "機器名",
  CL_OVERVIEW: "点検実施状況",
  SELECT_GROUP: "グループを選択",
  NUMBER_GROUP: "グループの数",
  TYPE_CHECKLIST: "点検頻度",
  REMARK_TYPE: "備考タイプ",
  STATE: "状態",
  STATUS: "ステータス",
  REJECT_REASON: "理由拒否",
  STATUS_MACHINE: "機械ステータス",
  PERSON_IN_CHARGE: "担当者",
  DELETE_BOOKMARK: "削除ブックマーク",
  ADD_BOOKMARK: "ブックマック追加",
  DELETE_HOMEPAGE: "ホームページ削除",
  ADD_HOMEPAGE: "ホームページ追加",
  COMMON: "共通",
  WARNING_SAVE_NORMAL:
    "入力したデータにて、運転めやす範囲を超える数字がありますが、「正常保存」してもよろしいですか？",
  WARNING_HAS_NONE_INPUT:
    "未点検の点検項目があり、そのまま他の画面に遷移しますか？",
  DETAIL_CHECKLIST_TITLE: "点検詳細",
  INCOMPLETE: "未完成",
  EDITOR: "更新者",
  TIMES: "回目",
  MORE_TIMES: "複数回",
  TIME_CHECKING: "点検時刻",
  BEGIN_CHECK: "点検開始日時",
  END_CHECK: "点検完了日時",
  HISTORY_RECORD: "記録履歴",
  MAIN_CHECKER: "主記録者",
  CHECK_TIMES: "チェック回数",
  TIMES_NOT_VALUE: "回目の点検項目しない",
  NOTE: "備考",
  PHOTO: "写真",
  COMMENT: "コメント",
  ADD_IMAGE: "写真を追加する",
  PREVIOUS_VALUE: "前回の値",
  RANGE: "範囲",
  REFER_VALUE_PREVIEW: "値を記入",
  VALUE: "値",
  NO: "無",
  YES: "有",
  HIGH: "高",
  MIDDLE: "中",
  LOW: "低",
  REGISTRY_CHECKLIST: "点検表登録",
  NAME_SHEET: "シート名",
  NUMBER_ROW: "行番号",
  MESSAGE: "メッセージ",
  PLEASE_SELECT_SITE: "サイトオフィスを選択してください!",
  PLEASE_CHOOSE_FILE: "ファイルを入力してください!",
  DO_YOU_WANT_TO_REGISTRY: "入力内容を登録してもよろしいですか",
  PLEASE_INPUT_NAME_TEMPLATE: "テンプレート名を入力してください",
  PLEASE_INPUT_CATEGORY: "カテゴリーを入力してください",
  TEMPLATE_MUST_IS_EXCEL_FILE:
    "テンプレートはExcelファイルである必要があります!",
  INFO_TEMPLATE_REPORT: "報告テンプレート情報",
  NAME_OF_TEMPLATE_HAS_EXISTED:
    "テンプレートの名前は既にシステムに存在しています",
  GROUP_CL_HAS_EXISTED: "グループ名は既に存在しています",
  REGISTRY_TEMPLATE: "報告テンプレート登録",
  EDIT_TEMPLATE: "報告テンプレート編集",
  TEMPLATE_CODE: "テンプレートコード",
  SELECT_FILE: "インポートファイル選択",
  NAME_OFFICE_SITE: "事業所名",
  EXPORT_REPORT_CHECKLIST: "点検情報出力",
  EXPORT_REPORT_INVENTORY: "倉庫マスターデータ出力",
  EXPORT_MASTER_DATA: "マスタデータ出力",
  EXPORT_OFFICE_SITE_DATA: "事業所サイトデータ出力",
  EXPORT_TEMPLATE_CL: "テンプレート出力",
  DYNAMIC_CHART: "動的レポート",
  IMPORT_MASTER_DATA: "マスタデータ登録",
  IMPORT_OFFICE_SITE_DATA: "事業所サイトデータ登録",
  IMPORT_TEMPLATE_CL: "ファイル入力",
  REGISTRY: "登録",
  JUDGEMENT: "判定",
  LIST_BOOKMARK: "ブックマーク一覧",
  LIST_CHECK_RESULT: "実行中一覧",
  HOMEPAGE: "ホームページ",
  HOME_BANNER: "お知らせ",
  SAVE_CL_DRAFT: "に既に保存されていますが、結果を統合しますか。",
  SAVE_CL_CRAFT_WITH_NO_MERGE:
    "によって既に保存されています。点検データを上書きしますか？（既に保存されている点検データは削除されます）",
  CREATED: "作成する ",
  DO_YOU_WANT_TO_OVERRIDE: "上書きしてもよろしいでしょうか？",
  OPERATION_MANAGEMENT: "運転管理",
  LOG_OUT: "ログアウト",
  LIST_GROUP_CHECKLIST: "点検表一覧",
  LIST_TARGET_CHECKLIST: "点検対象一覧",
  COPYRIGHT:
    "Copyright © Sumitomo Heavy Industries Environment Co.,Ltd. All Rights Reserved.",
  TEMPLATE_NAME: "テンプレート名",
  APPROVER: "承認者",
  INSPECTION_DATE: "点検日付",
  INSPECTION_PERSON: "点検者",
  SHEET: "シート",
  CATEGORY: "カテゴリー",
  OTHER_DATE: "日付",
  REGISTRATION_DATE: "登録日付",
  SEARCH_KEYWORD: "検索キーワード",
  EDITING_DATE: "更新日時",
  TARGET_DATE: "対象日付",
  TARGET_WEEK: "対象週付",
  TARGET_MONTH: "対象年月",
  TARGET_YEAR: "対象年度",
  ACCESS_NUMBERS: "該当件数",
  BEGIN_DATE_TO_END_DATE: "開始日 ～ 終了日",
  END_DATE_CHECK_CHECKLIST: "点検終了日時",
  CASE: "件",
  PLEASE_INPUT_NAME: "名前を入力してください",
  INPUT_FIELD_DO_NOT_SPECIAL_CHAR: "データ入力は特殊文字を許可しません",
  CURRENT_CHECKLIST_IS_PROCESSING: "実施中の点検画面が前のページに戻ります。",
  DO_YOU_SAVE_DRAFT_CHECKLIST: "入力されたデータを保存しますか？",
  SAVE_DRAFT_CL: "◎下書保存：データは「進行中」に保存されます。",
  CANCEL_SAVE_CL: "◎キャンセル：入力したデータは保存されません。",
  CHECKLIST_HAS_ADDED_IS_NOT_DISPLAYED_IN_RESULT:
    "※検査表に追加されている点検対象は検索結果に表示させません。",
  CAN_NOT_DOWNLOAD_DATA_NOT_EXISTED:
    "指定した日付は以下のデータが存在しない為、ダウンロードが出来ません。もう一度ご確認ください。",
  LOADING: "読み込み中...",
  CONNECTED: "接続済み",
  DISCONNECTED: "インターネット接続なし",
  SEND: "送信中",
  UNSENT: "未送信点検表",
  DOWNLOAD: "ダウンロード",
  REJECT_CHECKLIST_SUCCESS: "正常に拒否しました。",
  CONFIRM_CHECKLIST_SUCCESS: "正常に確認しました。",
  APPROVE_CHECKLIST_SUCCESS: "正常に承認しました。",
  SOLVED_NORMALLY: "正常に解決しました。",
  WORK_REPORT_INFORMATION: "作業報告情報",
  REPORT_INFO: "報告情報",
  CHECK_RESULT_DESTINATION: "点検表結果先",
  CONFIRMER_MAIL_ADDRESS: "確認者のメールアドレス",
  APPROVED_MAIL_ADDRESS: "承認者のメールアドレス",
  PART_NAME: "部品名",
  QUANTITY: "数量",
  PRECAUTION_TROUBLE_DETAIL: "注意事項・トラブル内容",
  NO_INDEX: "連番",

  ACCUMULATED_VALUE: "総累計",
  CURRENT_VALUE: "現在の値",
  ADD_COMMENT: "コメントを追加",
  PLEASE_UPLOAD_WHEN_HAS_INTERNET:
    "インターネットが不安定なエリアのため写真のアップロードができません。インターネットが安定しているエリアで再度アップロードして下さい。",

  // home banner
  HOME_BANNER_MANAGEMENT: "お知らせ管理",
  HOME_BANNER_INFORMATION: "お知らせ情報",
  HOME_BANNER_CREATE: "お知らせ登録",
  HOME_BANNER_UPDATE: "お知らせ更新",
  SEE_MORE: "もっと見る",
  TITLE: "タイトル",
  TYPE: "種類",
  CONTENT: "内容",
  //2023.01.16 ADD START Add name of column for gridview screen revert ParentContract TamNM10
  DEPARTMENT_NAME: "部門名",
  REPRESENTATIVE_NAME: "代表者名",
  CONSTRUCTION_NAME: "工事名称",
  CONTRACT_TERM: "契約年月日",
  BOOKER_NAME: "契約先名称",
  CONFIRM_CHECKED_DATE: "検査完了年月日",
  MANAGE_USER: "ユーザ管理",
  BUSINESS_PARTNER_MASTER: "取引先マスター",
  ORDER_AMOUNT: "受注金額",
  //2023.01.16 ADD END Add name of column for gridview screen revert ParentContract TamNM10
  //function-machine-management
  FUNCTION_CUSTOMIZATION_SETTINGS: "機能カスタマイズ設定",
  FUNCITION_NAME: "機能名",
  FUNCTION_ID: "機能ID",
  OFFICE: "事業所",
  ALL_FACTORY: "全事業所",
  FUNCTION_PARENT_NAME: "親メニュー",
  MACHINE_MANAGEMENT: "機器台帳管理",

  //machine-management
  MACHINE_NAME: "機器名",
  MACHINE_MANUFACTURE_NAME: "メーカー名",
  MACHINE_STATUS: "ステータス",
  MACHINE_STATUS_VALUE: [
    {
      key: 1,
      value: "稼働中",
    },
    {
      key: 2,
      value: "停止中",
    },
    {
      key: 3,
      value: "休止中",
    },
    {
      key: 4,
      value: "故障中",
    },
    {
      key: 5,
      value: "修理中",
    },
    {
      key: 6,
      value: "廃棄",
    },
  ],
  MACHINE_INSTITUTION: "施設",
  MACHINE_ADD: "機器台帳新規作成",
  VIEW_MACHINE: "",
  EDIT_MACHINE: "機器台帳更新",
  NAME_MACHINE: "機器名",
  NAME_FACILITY: "施設名",
  NAME_BUILDING: "棟名",
  NAME_FLOOR: "階名",
  NAME_ROOM: "部屋名",
  NAME_PROCESS: "プロセス名",
  MODEL: "型式",
  SERI_NUMBER: "シリアル番号",
  STATUS_MACHINE: "ステータス",
  SET_TIME: "設置年月",
  SPECIFICATIONS: "主仕様",
  SERVICE_LIFE: "耐用年数",
  DRAWING_NUMBER: "図面明細番号",
  MADE: "製番",
  USE: "用途",
  SERVICE_LIFE_IN_HOUSE: "耐久年数（自社）",
  YEAR_OF_MANUFACTURE: "製造年度",
  DUABILITY: "耐用時間",
  REPLACEMENT_DISPOSAL_YEAR: "取替廃棄年月",
  CONDITION: "コンディション",
  TITLE_POPUP_EDITMACHINE: "更新履歴",
  DATE_REGISTER_MACHINE: "登録日付",
  MACHINE_CODE: " 機器コード",
  MACHINE_LEDGER_INFOMATION: "機器台帳情報",
  MACHINE_LEDGER_UPDATE: "機器台帳更新",
  MACHINE_LEDGER_ADD: "機器台帳新規作成",
  MACHINE_IMPORT: "機器台帳一括作成",
  REMARK: "備考",
  UPDATE_TYPE: "更新種類",
  UPDATE_CONTENT: "更新内容",
  ATTACH_FILE: "添付ファイル",
  ATTACH_NOTE: "※ファイルサイズの上限は100MBです。",
  PROJECT: "項目",
  INSPECTION_TIME_NAME: "点検項目名",
  CONTROL_VALUE_LOW: "管理値(下限値)",
  CONTROL_VALUE_UPPER: "管理値(上限値)",
  EASY_DRIVE_LOW: "運転めやす(下限値)",
  EASY_DRIVE_UPPER: " 運転めやす(上限値)",
  INVENTORY_LINKAGE: "在庫連携",
  INVENTORY_ITEM: "在庫項",
  QUANTITY_LEFT_IN_WAREHOUSE: "倉庫残量",
  USED_QUANTITY: "使用済数量",
  TYPE_MACHINE: "種類",
  QUANTITY_MACHINE_STOCK: "在庫数量へ",
  INPUT_FORMAT: "入力形式",
  UNIT: "単位",
  SELECTION: "選択",
  LETTER: "文字",
  INSPECTION_FREQUENCY: "点検頻度",
  CHANGE_LOG: "更新履歴",
  CHANGE_DATE: "変更日付",
  DEVICE_LEDGER_HISTORY: "機器台帳履歴",
  MAINTAINCE_HISTORY: "保全履歴",
  MAINTAINCE_DATE: "実施年月日",
  MAINTAINCE_DIVISION: "施工業者",
  MAINTAINCE_PIC: "区分",
  MAINTAINCE_OVERVIEW: "概要",
  MAINTAINCE_WORK_CONTENT: "作業内容",
  MAINTAINCE_TEMPLATE: "テンプレート出力",

  //location management
  LOCATION_MANAGEMENT: "機器台帳",
  FACILITY_MANAGEMENT: "施設管理",
  FACILITY_MANAGEMENT_INFOMATION: "施設管理情報",
  PROCESS_MASTER_NAME: "プロセスマスタ名",
  PROCESS_CONTROL_INFOMATION: "プロセス管理情報",
  PROCESS_MANAGEMENT_REGISTRATION: "プロセス管理登録",
  PROCESS_MANAGEMENT_UPDATE: "プロセス管理更新",
  PROCESS_MANAGEMENT: "プロセス管理",
  COMPLETION_DATE: "竣工年月日",
  ADDRESS: "住所",
  APPLICABLE_START_DATE: "適用開始日",
  APPLICABLE_END_DATE: "適用終了日",
  FACILITY_MANAGER: "施設責任者",
  POST_CODE: "郵便番号",
  NAME_OF_PREFECTURE: "都道府県名",
  PROCESSING_METHOD: "処理方式",
  PROCESSING_POWER: "処理能力",
  SITE_MANAGEMENT: "場所管理",
  NAME_FACILITY: "施設名",
  NAME_BUILDING: "棟名",
  NAME_FLOOR: "階名",
  NAME_ROOM: "部屋名",
  NAME_PROCESS: "プロセス名",
  REMARK: "備考",
  FACILITY_MANEGEMENT_INFO_UPDATE: "施設管理情報更新",
  FACILITY_MANEGEMENT_INFO_ADD: "施設管理情報登録",
  PLANT_NAME: "機種名",
  MESS_CONFIRM_SAME_BUILDING_NAME: "棟が重複されています。再入力してください。",
  MESS_CONFIRM_SAME_FLOOR_NAME: "階が重複されています。再入力してください。",
  MESS_CONFIRM_SAME_ROOM_NAME: "部屋が重複されています。再入力してください。",
  FACILITY_MANEGEMENT_INFO_UPDATE: "施設管理情報更新",
  FACILITY_MANEGEMENT_INFO_ADD: "施設管理情報登録",
  PLANT_NAME: "機種名",
  MANY_ATTACH: "一括ファイル出力",
  EVERYONE: "全員",
  DESIGNATED_PERSON: "指定人",
  USER_NAME: "ユーザ名",
  RECIPIENT: "受信人",

  MAIL_ADDRESS: "メールアドレス",
  SIGN_IN: "サインイン",

  // Contract
  // DungDV21
  CONTRACT_PARENT: "元請簿",
  OYASEINO: "製番",
  KJIRYKNM: "工事名称",
  DATE_FROM: "契約年月日",
  DATE_TO: "検査完了年月日",
  HOVER_CONFIRM: "確定",
  HOVER_CANCEL: "解除",
  BUTTON_DELETE: "解除",
  HOVER_DELETE: "取消",
  DELETE_ALL: "一括取消",

  // TuanNA95
  REPRESENTATIVE_MASTER: "代表者マスター",
  REPRESENTATIVE_TXT: "代表者",
  REPRESENTATIVE_OFF_NAME: "営業所名",
  REPRESENTATIVE_DATE: "就任日",
  REPRESENTATIVE_CREATE: "代表者登録",
  REPRESENTATIVE_UPDATE: "代表者更新",

  //<HieuLD6>
  REJECT_SUBCONTRACT: "下請簿",
  PARTNER_CODE: "取引先コード",
  DEPARTMENT: "部門名",
  CONSTRUCTION: "工事名称",
  LOCATION_NAME: "納入先名称",
  CONTRACT_TERM: "契約年月日",
  ARRANGEMENT_NUMBER : "手配番号",
  PRODUCT_NAME : "品名",
  ORDER_AMOUNT2 : "発注金額",
  SUBCONTRACTOR: "下請人名",
  SUBCONTRACTOR_TYPE: "下請人の区分",
  ADD_CONTRACTOR_NUMBER: "許可番号登録",
  DATE_CHECKED: "検査完了年月日",
  ACCEPT_TYPE: "検収区分",
  BACK: "復旧",
  NUMBER: "件数",
  PERMITCATEGORY: "許可区分",
  MSGDUPLICATEROW: "許可番号が存在しています。",
  MSGDECONTRCTNUMBER: "この許可番号は下請簿で使用していますので、削除できません。",
  MSGINPUTNUMBERLENGTH: "6桁で番号を入力してください。",
  GENERALSPECIFIC: "一般/特定",
  ERANAME: "年号",
  INPUTNUMBER: "番号",
  REJECT_SUBCONTRACT_DETAIL: "下請詳細情報",
  LOCATION_PROVINE: "納入先住所（都道府県）",
  LOCATION_DISTRICT: "納入先住所（市町村以下）",
  SUBCONTRACTOR_ADDRESS: "下請人住所",
  SUBCONTRACTOR_CONTRUCTION_PERMIT_NUMBER: "下請人の建設業許可番号",
  CAPITAL: "資本金",
  DATE_FINSHED_CHECK: "検査完了年月日",
  DELIVERY_DATE: "引渡年月日",
  SUBCONTRACT_PAYMENT_RULES: "下請代金支払条件 ",
  PAYMENT_RULES: "表示用支払条件",
  SUBCONTRACT_PAYMENT_STATUS: "下請代金支払状況",
  ATTACHED_DOCUMENT: "添付書類",
  TEXT_COMPLETED_CONTRACT:"下請簿完了",
  OFFICE_NAME: "営業所名",
  REPRESENTATIVE_NAME: "代表者名",
  CUSTOMER_NAME: "契約先名称",
  CUSTOMER_ADDRESS: "契約先住所",
  DELETE: "取消",
  DELETE1: "削除",
  LIST_DELETE: "取消一覧",
  ACCEPT: "確定",
  CONTRACT_DETAIL: "元請情報",
  REPRESENTATIVE_CONTRACT: "代表者マスター",
  DELETE_ALL_BUTTON: "一括取消",
  REVERT_ALL_BUTTON: "一括復旧",
  SUBCONTRACTOR_PERMISSION_NUMBER: "下請許可番号選択未",
  //</HieuLD6>
  DEFAULT_DISPLAY_TXT: "デフォルトで直近1年分を表示してます。",
  EDIT_CONTRACT_TITLE: "元請編集",
  EDIT_BOTTOM_TITLE: "元請情報",
  EDIT_CONTRACT_BUTTON: "編集",
  ADD_SUB_CONTRACT: "下請作成",
  BUTTON_MAKE_SURE: "元請確定",
  UPDATE_LOCK: "更新ロック"
};

export const KEY = {
  GROUP_TYPE_COMMON: "1",
  GROUP_TYPE_USER: "2",
  LAPTOP_WIDTH: "(min-device-width: 1000px)",
  PORTRAIT_MOBILE_WIDTH: "(max-width: 500px)", // rotate screen in mobile
  NOTI: "NOTI",
  ERROR: "ERROR",
  INFO: "INFO",
  CONFIRM: "CONFIRM",
  WARMING: "WARMING",
  DISABLED: "DISABLED",
  NUMBER: "Number",
  TEXT: "Text",
  DDL: "DropDownList",
  CHECKBOX: "Checkbox",
  TEXTAREA: "TEXTAREA",
  DATEPICKER: "DATEPICKER",
  IMPORT: 1,
  EXPORT: 2,
  SORT_TABLE: "SORT_TABLE",
  IMAGE: "image",

  APPROVE: "0",
  UNAPPROVE: "1",
  REJECT: "2",
  WORKING: "3",
  DONE: "4",
  DONE_AB: "5",
  TIMING_DATE: "1",
  REMARK_DEFAULT: "1",

  // Setting menu
  LOC_USER_INFO: "uInfo",
  USER_ROLE: "userRole",
  MENU_SETTING: "menuSetting",
  MENU_ADMIN_OFFICE: "2", // office admin
  MENU_ADMIN: "1", // head office
  UPDATE_LOCK: "0",

  // Format date
  DATE_DEFAULT: "YYYY/MM/DD",
  WEEK: "YYYY-WW",
  MONTH: "YYYY/MM",
  YEAR: "YYYY",
  MONTH_DATE: "MM/dd",
  MONTH_DATE_MOMENT: "MM/DD",
  DATE_WITHOUT_HOUR: "yyyy/MM/dd",
  DATE_WITH_HOUR: "yyyy/MM/dd HH:mm",
  DATE_WITH_HOUR_DESKTOP: "YYYY/MM/DD HH:mm",
  HOUR_24H: "HH:mm",
};

export const STYLE = {
  BORDER_RED: "border-red",
};

export const CONFIG = {
  paging: { position: ["bottomCenter"], pageSize: 15, hideOnSinglePage: true },
};
export const LIMIT = 30;
export const PAGE_SIZE = 10;
